(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["er-custom-studio"] && !Shopify.designMode) return;
  try {
    (function initCustomStudio() {
    const root = document.querySelector('[data-section-id="{{ cs_id }}"]');
    if (!root) return;
    root.querySelectorAll('a[href="#custom-bulk-quote"]').forEach((link) => {
      link.addEventListener('click', (e) => {
        const target = document.getElementById('custom-bulk-quote');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["er-men-tech-specs"] && !Shopify.designMode) return;
  try {
    (function initMenTech() {
    const root = document.querySelector('[data-section-id="{{ mt_id }}"]');
    if (!root) return;
    const filters = root.querySelectorAll('.men-tech__filter');
    const cards = root.querySelectorAll('[data-men-product-grid] .men-tech__card');
    if (!filters.length || !cards.length) return;
    filters.forEach((btn) => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.filter;
        filters.forEach((b) => {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
        cards.forEach((card) => {
          const tags = (card.dataset.filters || '')
            .split(',')
            .map((t) => t.trim())
            .filter(Boolean);
          card.classList.toggle('is-hidden', key !== 'all' && !tags.includes(key));
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["er-pre-order-early-access"] && !Shopify.designMode) return;
  try {
    (function initPreOrderProgress() {
    document.querySelectorAll('.pre-order [data-preorder-progress] .pre-order__progress-fill').forEach((fill) => {
      const target = fill.style.getPropertyValue('--progress') || '0%';
      fill.style.width = '0%';
      requestAnimationFrame(() => {
        fill.style.width = target;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["er-women-lifestyle-grid"] && !Shopify.designMode) return;
  try {
    (function initWomenLifestyle() {
    const root = document.querySelector('[data-section-id="{{ wl_id }}"]');
    if (!root) return;

    const filters = root.querySelectorAll('.women-lifestyle__filter');
    const cards = root.querySelectorAll('[data-women-product-grid] .women-lifestyle__card');

    if (filters.length && cards.length) {
      filters.forEach((btn) => {
        btn.addEventListener('click', () => {
          const key = btn.dataset.filter;
          filters.forEach((b) => {
            b.classList.toggle('is-active', b === btn);
            b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
          });
          cards.forEach((card) => {
            const tags = (card.dataset.filters || '')
              .split(',')
              .map((t) => t.trim())
              .filter(Boolean);
            const show = key === 'all' || tags.includes(key);
            card.classList.toggle('is-hidden', !show);
          });
        });
      });
    }

    root.querySelectorAll('[data-ugc-quick-add-trigger]').forEach((bagBtn) => {
      bagBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const tile = bagBtn.closest('.women-lifestyle__ugc-item');
        const quickAdd = tile?.querySelector('quick-add-component');
        if (!quickAdd) return;

        const trigger =
          quickAdd.querySelector('.quick-add__button--choose') ||
          quickAdd.querySelector('.quick-add__button--add');
        trigger?.click();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
